<div
  class="parameters-container"
  [ngClass]="showParametersRoutes ? 'parameters-container-expanded' : ''"
>
  <div class="bg-white p-3 h-100 w-100 overflow-auto list-item" *ngIf="showParametersRoutes">
    <div class="d-flex flex-column h-100">
      <h5 class="text-primary d-flex align-items-center m-0">
        {{ parametersRoutes.label | abpLocalization }}
      </h5>

      <dw-ui-section-grouping-routing
        [routes]="parametersRoutes.sections"
      ></dw-ui-section-grouping-routing>
    </div>
  </div>

  <div class="col bg-white d-block h-100">
    <router-outlet></router-outlet>
  </div>
</div>
